import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/img/download-arrow.svg")